import {
  Card,
  CardTitle,
  Button,
  Row,
  Col,
} from 'reactstrap';
import { useNavigate } from "react-router-dom";
import subscriptionNames from "./subscriptionData";
import { getUser } from "../../service/AuthService";
import { Fragment } from 'react';

const Cards = () => {
  const user = getUser();
  const name = user !== 'undefined' && user ? user.name : '';
  const username = user !== 'undefined' && user ? user.username : '';
  const organization = user !== 'undefined' && user ? user.organization : '';
  const subscriptions = user !== 'undefined' && user ? user.subscriptions : '';
  const subscriptionList = subscriptions ? subscriptions.split(',') : [];
  const navigate = useNavigate();

  const subscribeHandler = () => navigate('/Contactus');
  const tutorialHandler = () => navigate('/Contactus');

  const cardHandler = (name) => {
    if (name === "AI Model Building") navigate('/ModelBuilder');
    if (name === "Product Pricing") navigate('/VendorPriceTable');
    if (name === "Behavior Analytics") navigate('/BehaviorAnalytics');
  };

  let displaySubscriptions = [...subscriptionNames];

  // Show Behavior Analytics only if org = techcomb AND subscriptionList includes it
  if (
    organization &&
    organization.toLowerCase() === "techcomb" &&
    subscriptionList.includes("Behavior Analytics")
  ) {
    if (!displaySubscriptions.includes("Behavior Analytics")) {
      displaySubscriptions.push("Behavior Analytics");
    }
  }

  return (
    <div>
      <Row className="mb-2">
        <Col xs="12">
          <h5 className="font-md-lg font-bold text-center">Your Active Subscriptions</h5>
        </Col>
      </Row>

      <Row className="g-4">
        {displaySubscriptions.map((name) => (
          <Fragment key={name}>
            {subscriptionList.includes(name) ? (
              <Col md="6" lg="3">
                <Card
                  body
                  color="light-success"
                  style={{ cursor: "pointer" }}
                  onClick={() => cardHandler(name)}
                >
                  <CardTitle tag="h5">{name}</CardTitle>
                  <div>
                    <Button onClick={tutorialHandler}>View Tutorial</Button>
                  </div>
                </Card>
              </Col>
            ) : (
              <Col md="6" lg="3">
                <Card body color="light-danger">
                  <CardTitle tag="h5">{name}</CardTitle>
                  <div>
                    <Button onClick={subscribeHandler}>Subscribe Now</Button>
                  </div>
                </Card>
              </Col>
            )}
          </Fragment>
        ))}
      </Row>
    </div>
  );
};

export default Cards;